// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"57484804","586":"f9660f60"}[chunkId] + ".chunk.css";
};